export const createMockedId = () => Math.floor(Math.random() * 1000000);

export const getRandomItemFromArr = (arr) =>
  [...arr][Math.floor(Math.random() * arr.length)];
